<template>
  <div ref="content" class="content">
    <div class="container">
      <!--<PageBreadcrumb backName="最新动态" :backPath="$Enum.RouterEnum.News"-->
      <!--                :currentName="request.data.detail.title" />-->
      <a-row :gutter="[20,0]">
        <a-col :xs="24" :xl="16">
          <a-skeleton :loading="request.data.detail.title===''" :paragraph="{rows:8}" active>
            <div class="box_article">
              <a-typography-title :level="1">
                {{ request.data.detail.title }}
              </a-typography-title>
              <a-typography-paragraph>
                <a-row>
                  <a-col :span="24">
                    <blockquote>
                      发布日期：{{ request.data.detail.time === 0 ? '-' : $FN.Time.format(request.data.detail.time * 1000) }}
                    </blockquote>
                  </a-col>
                  <!--<a-col :span="12">-->
                  <!--    作者：{{ request.data.detail.author }}-->
                  <!--</a-col>-->
                </a-row>
              </a-typography-paragraph>
              <div class="article" v-html="request.data.detail.text" />
            </div>
          </a-skeleton>
        </a-col>
        <a-col :xs="24" :xl="8">
          <a-skeleton :loading="request.data.list.length===0" active>
            <a-typography-title :level="5" class="recommend">
              动态推荐
            </a-typography-title>
            <a-row :gutter="[20,0]">
              <a-col v-for="item in request.data.list"
                     :xs="24" :sm="8" :xl="24">
                <a class="card" @click="switchDetail(item.article_id)">
                  <i :style="{backgroundImage:`url('${item.article_cover_address}')`}" />
                  <a-typography-title :level="5">
                    {{ item.article_title }}
                  </a-typography-title>
                </a>
              </a-col>
              <a-col :xs="0" :xl="24">
                <div class="box_qr">
                  <img alt=""
                       :src="file.ImageQR" />
                  <p>
                    扫码添加小助手，回复“白皮书”<br>
                    获取更多行业干货
                  </p>
                  <span></span>
                </div>
              </a-col>
            </a-row>
          </a-skeleton>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import {
  RequestGetNewsTop, ResponseGetNewsTop, AxiosGetNewsTop,
  RequestGetNewsDetail, ResponseGetNewsDetail, AxiosGetNewsDetail
} from '@server/apiNews';
import PageBreadcrumb from '@template/page/_component/breadcrumb.vue';
import ImageQR from '@resource/image/public/qr_assistant.jpg';

export default {
  name: 'newsContent',
  components: {
    PageBreadcrumb
  },
  data(): DataInterface {
    return {
      file: {
        ImageQR
      },
      request: {
        intercept: {
          detail: false,
          list: false
        },
        data: {
          detail: {
            title: '',
            introduction: '',
            text: '',
            image: '',
            author: '',
            time: 0
          },
          list: []
        }
      },
      form: {
        data: {
          article_id: this.$route.query.id || ''
        }
      }
    };
  },
  mounted(): void {
    if (this.form.data.article_id === '') {
      this.$router.push($Enum.RouterEnum.News);
    } else {
      this.getDetail();
      this.getList();
    }
  },
  methods: {
    /**
     * 滚动至新闻内容顶部
     */
    scroll(): void {
      const domContent = this.$refs.content;
      
      if (!domContent) return;
      
      window.scrollTo(0, 0);
      window.scrollTo(0, domContent.getBoundingClientRect().top - ($Store.Public().isGridMatch('>=', $Enum.GridEnum.XL) ? 110 : 60) - 20);
    },
    
    /**
     * 切换新闻
     * @param {} id
     */
    switchDetail(id: string) {
      this.$router.push({ query: { id } });
      this.form.data.article_id = id;
      this.scroll();
      this.getDetail();
    },
    
    /**
     * 获取文章
     */
    getDetail() {
      if (this.request.intercept.detail) return;
      this.request.intercept.detail = true;
      
      AxiosGetNewsDetail(this.form.data as RequestGetNewsDetail)
        .then((response: any) => {
          const data: ResponseGetNewsDetail = response.data;
          
          this.request.intercept.detail = false;
          if (data.code !== $Enum.CodeEnum.Normal) {
            this.$router.push($Enum.RouterEnum.News);
            return;
          }
          
          this.request.data.detail.title = data.data.article_title;
          this.request.data.detail.introduction = data.data.article_introduction;
          this.request.data.detail.text = data.data.article_text;
          this.request.data.detail.image = data.data.article_cover_address;
          this.request.data.detail.author = data.data.article_nick_name;
          this.request.data.detail.time = data.data.published_at;
        })
        .catch(() => {
          this.request.intercept.detail = false;
        });
    },
    
    /**
     * 获取列表
     */
    getList(): void {
      if (this.request.intercept.list) return;
      this.request.intercept.list = true;
      
      AxiosGetNewsTop({} as RequestGetNewsTop)
        .then((res: any) => {
          const data: ResponseGetNewsTop = res.data;
          
          this.request.intercept.list = false;
          if (data.code !== $Enum.CodeEnum.Normal) return;
          
          this.request.data.list = data.data.article_data;
        })
        .catch(() => {
          this.request.intercept.list = false;
        });
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';
@import '@resource/css/article.less';

@image: '@{src_image}page/news/';

.content {
  overflow: hidden;
  position: relative;
  width: 100%;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
}

.ant-row {
  margin: 20px 0 0;
}

.box_article {
  padding: 0 0 100px;
  
  h1.ant-typography {
    margin: 0 0 10px;
    .font(justify, @title+@line, @color_1, @title, true);
  }
}

.recommend {
  margin: 5px 0 20px;
  .font(left, @text_big, @color_blue, @text_big);
}

.card {
  display: block;
  overflow: hidden;
  position: relative;
  height: 220px;
  margin-bottom: 20px;
  .borderBox();
  border-radius: 5px;
  
  &:hover {
    i {
      .transform(scale(1.1));
    }
  }
  
  i {
    .position();
    z-index: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    .transition(transform @time);
    pointer-events: none;
  }
  
  h5.ant-typography {
    @sh: 50px;
    .position(bottom);
    z-index: 1;
    height: @sh;
    padding: 0 @padding;
    margin: 0;
    background-color: fade(@color_black, 50);
    .font(center, @sh, @color_white, 18px);
    .ellipsis();
  }
}

.box_qr {
  overflow: hidden;
  position: relative;
  height: 255px;
  margin: 0 0 50px;
  .borderBox();
  border: 1px solid @color_4;
  border-radius: 5px;
  
  &::before {
    content: "";
    display: block;
    .position(bottom);
    z-index: 0;
    .bg('@{image}qr_bg.jpg', 100%, 140px, true);
  }
  
  img {
    display: block;
    .position(top, 30px);
    width: 150px;
    margin: 0 auto;
  }
  
  p {
    @ph: 20px;
    .position(top, 180px);
    width: 220px;
    height: @ph;
    margin: 0 auto;
    .font(center, @ph, @color_black, @font_7);
  }
  
  span {
    @ph: 20px;
    .position(top, 200px);
    width: 220px;
    height: @ph;
    margin: 0 auto;
    .font(center, @ph, @color_3, @font_7);
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .box_article {
    padding: 0;
    
    blockquote {
      margin: 0;
    }
    
    h1.ant-typography {
      .font(justify, @title_mo+@line_mo, @color_1, @title_mo, true);
    }
  }
  
  .recommend {
    margin: 50px 0 0;
    .font(left, @text_big_mo, @color_blue, @text_big_mo);
  }
}
</style>